// /**
//  * Order -CSV
//  */

// React
import React from 'react';

import {CSVLink} from 'react-csv';

// UI
import {Button} from '@material-ui/core';

import jMoment from 'moment-jalaali';

// Icon
import Icon from '@mdi/react';
import {mdiTableArrowUp} from '@mdi/js';


type Props = {
  ordersDispatch: any;
  data: object[];
  filtersValues: any;
  loading: boolean;
};

function CSV(props: Props) {
  const handleCreateCSV = () => {
    props.ordersDispatch({...props.filtersValues, size: 10000});
  };
  const flattData = (data: any) => {
    const newData = data.map(el => {
      return {
        parcelItemId: el.id,
        productName: el.productName,
        productCode: el.productCode,
        variantId: el.skuId,
        variantCode: el.variantCode,
        count: el.count
      };
    })
    return newData
  };

  return (
    <>
      {props.data?.length > 0 ? (
        <CSVLink
          data={flattData(props.data)}
          filename="parcelVariants.csv"
          style={{
            backgroundColor: '#DFA01F',
            padding: '10px',
            color: '#fff',
            marginLeft: '5px',
            textDecoration: 'none',
          }}
        >
          دانلود CSV
        </CSVLink>
      ) : (
        <Button
          style={{marginLeft: '5px'}}
          variant="contained"
          color="primary"
          startIcon={<Icon path={mdiTableArrowUp} size={1} />}
          onClick={handleCreateCSV}
          disabled={props.loading}
        >
          ایجاد فایل CSV
        </Button>
      )}
    </>
  );
}

export default CSV;
